import { createFileRoute } from "@tanstack/react-router";
import { StationReportPage } from "@/features/station-report/station-report-page";

// Okno helpera agenta (WebView): bez logowania, token zgłoszenia z `window.__FM_REPORT__`.
export const Route = createFileRoute("/zgloszenie")({
	component: StationReportPage,
});
